(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["connect-with-us"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = new WeakSet();
    let activeRoot = null;
    let lastFocusedElement = null;

    const socialOrder = ['instagram', 'facebook', 'youtube', 'whatsappChannel', 'pinterest'];

    const getConfig = (root) => {
      if (root.mmConnectConfig) return root.mmConnectConfig;

      const configNode = root.querySelector('[data-mm-connect-config]');
      let config = {};

      try {
        config = JSON.parse(configNode?.textContent || '{}');
      } catch (error) {
        config = {};
      }

      root.mmConnectConfig = {
        ...config,
        followerCounts: config.followerCounts || {},
        socialLinks: config.socialLinks || {},
      };

      return root.mmConnectConfig;
    };

    const prepareRoot = (root) => {
      if (root.dataset.mmPrepared === 'true') return;

      const config = getConfig(root);

      root.querySelectorAll('[data-mm-follower-count]').forEach((node) => {
        const key = node.getAttribute('data-mm-follower-count');
        if (config.followerCounts[key]) {
          node.textContent = config.followerCounts[key];
        }
      });

      root.dataset.mmPrepared = 'true';
    };

    const getFocusable = (container) => {
      const selector = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
      ].join(',');

      return Array.from(container.querySelectorAll(selector)).filter((element) => {
        const style = window.getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
    };

    const openModal = (root) => {
      prepareRoot(root);

      const overlay = root.querySelector('[data-mm-connect-overlay]');
      const dialog = root.querySelector('[data-mm-dialog]');
      if (!overlay || !dialog) return;

      if (activeRoot && activeRoot !== root) {
        closeModal(activeRoot, false);
      }

      lastFocusedElement = document.activeElement;
      activeRoot = root;

      overlay.hidden = false;
      document.documentElement.classList.add('mm-connect-lock');
      requestAnimationFrame(() => {
        overlay.classList.add('is-open');
        const preferredFocus = root.querySelector('[data-mm-whatsapp]') || dialog;
        preferredFocus.focus({ preventScroll: true });
      });
    };

    const closeModal = (root, restoreFocus = true) => {
      const overlay = root.querySelector('[data-mm-connect-overlay]');
      if (!overlay || overlay.hidden) return;

      overlay.classList.remove('is-open');
      window.setTimeout(() => {
        overlay.hidden = true;
        if (activeRoot === root) {
          activeRoot = null;
          document.documentElement.classList.remove('mm-connect-lock');
        }

        if (restoreFocus && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus({ preventScroll: true });
        }
      }, 220);
    };

    const trapFocus = (event) => {
      if (!activeRoot || event.key !== 'Tab') return;

      const dialog = activeRoot.querySelector('[data-mm-dialog]');
      const focusable = dialog ? getFocusable(dialog) : [];
      if (!focusable.length) {
        event.preventDefault();
        dialog?.focus({ preventScroll: true });
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const readProduct = (root) => {
      const productNode = root.querySelector('[data-mm-product-json]');
      if (!productNode) return null;

      try {
        return JSON.parse(productNode.textContent || 'null');
      } catch (error) {
        return null;
      }
    };

    const getProductForm = (root) => {
      return root.closest('section')?.querySelector('form[action*="/cart/add"]')
        || document.querySelector('form[action*="/cart/add"]');
    };

    const getSelectedVariantId = (root) => {
      const form = getProductForm(root);
      const variantInput = form?.querySelector('[name="id"]');
      return String(variantInput?.value || root.dataset.selectedVariantId || '');
    };

    const getSelectedVariant = (root, product) => {
      const selectedVariantId = getSelectedVariantId(root);
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      return variants.find((variant) => String(variant.id) === selectedVariantId) || null;
    };

    const formatMoney = (root, cents) => {
      if (typeof cents !== 'number') return root.dataset.selectedVariantPrice || '';

      const currency = root.dataset.currency || window.Shopify?.currency?.active || 'INR';
      const locale = document.documentElement.lang || navigator.language || 'en-IN';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
        }).format(cents / 100);
      } catch (error) {
        return `${currency} ${(cents / 100).toFixed(2)}`;
      }
    };

    const getProductUrl = (root, variant) => {
      const baseUrl = root.dataset.productUrl || window.location.href;
      let url;

      try {
        url = new URL(baseUrl, window.location.origin);
      } catch (error) {
        url = new URL(window.location.href);
      }

      if (variant?.id) {
        url.searchParams.set('variant', variant.id);
      }

      return url.toString();
    };

    const buildWhatsAppMessage = (root) => {
      const product = readProduct(root);
      const variant = getSelectedVariant(root, product);
      const productTitle = product?.title || root.dataset.productTitle || document.title;
      const variantTitle = variant?.title || root.dataset.selectedVariantTitle || '';
      const variantPrice = formatMoney(root, variant?.price);
      const productUrl = getProductUrl(root, variant);
      const lines = [
        'Hi Modern Marwar, I need help with this product:',
        `Product: ${productTitle}`,
      ];

      if (variantTitle && variantTitle !== 'Default Title') {
        lines.push(`Variant: ${variantTitle}`);
      }

      if (variantPrice) {
        lines.push(`Price: ${variantPrice}`);
      }

      lines.push(`Link: ${productUrl}`);
      lines.push('Please assist me.');

      return lines.join('\n');
    };

    const openWhatsApp = (root) => {
      const config = getConfig(root);
      const number = String(config.whatsAppNumber || '').replace(/\D/g, '');
      const message = encodeURIComponent(buildWhatsAppMessage(root));
      const url = number ? `https://wa.me/${number}?text=${message}` : `https://wa.me/?text=${message}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    const followAll = (root) => {
      const config = getConfig(root);
      const fallbackLinks = Array.from(root.querySelectorAll('.mm-connect__follow')).map((link) => link.href);
      const configLinks = socialOrder.map((key) => config.socialLinks[key]).filter(Boolean);
      const links = configLinks.length ? configLinks : fallbackLinks;

      links.forEach((url, index) => {
        if (!url) return;

        const tab = window.open('', '_blank');
        if (tab) {
          tab.opener = null;
          window.setTimeout(() => {
            tab.location.href = url;
          }, index * 140);
          return;
        }

        window.setTimeout(() => {
          window.open(url, '_blank', 'noopener,noreferrer');
        }, index * 140);
      });
    };

    const addRipple = (target, event) => {
      const rect = target.getBoundingClientRect();
      const ripple = document.createElement('span');
      const x = event.clientX ? event.clientX - rect.left : rect.width / 2;
      const y = event.clientY ? event.clientY - rect.top : rect.height / 2;

      ripple.className = 'mm-connect-ripple';
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;
      target.appendChild(ripple);
      ripple.addEventListener('animationend', () => ripple.remove(), { once: true });
    };

    const onRootClick = (event) => {
      const root = event.currentTarget;
      const rippleTarget = event.target.closest('[data-mm-ripple]');

      if (rippleTarget && root.contains(rippleTarget)) {
        addRipple(rippleTarget, event);
      }

      if (event.target.closest('[data-mm-open]')) {
        openModal(root);
        return;
      }

      if (event.target.closest('[data-mm-close]') || event.target === root.querySelector('[data-mm-connect-overlay]')) {
        closeModal(root);
        return;
      }

      if (event.target.closest('[data-mm-whatsapp]')) {
        event.preventDefault();
        openWhatsApp(root);
        return;
      }

      if (event.target.closest('[data-mm-follow-all]')) {
        event.preventDefault();
        followAll(root);
      }
    };

    const onDocumentKeydown = (event) => {
      if (!activeRoot) return;

      if (event.key === 'Escape') {
        closeModal(activeRoot);
        return;
      }

      trapFocus(event);
    };

    const init = () => {
      document.querySelectorAll('[data-mm-connect-root]').forEach((root) => {
        if (roots.has(root)) return;
        roots.add(root);
        root.addEventListener('click', onRootClick);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('keydown', onDocumentKeydown);
  })();
  } catch(e) { console.error(e); }
})();

})();
